<div class="modal-wrapper sm:max-w-md md:max-w-lg p-0! overflow-hidden">

    <!-- header -->
    <div class="flex items-center justify-between mb-0! pt-6 px-6 pb-4">
        <div>
            <h3 class="modal-title">
                {{ options?.title | translate }}
            </h3>
            <p class="text-base text-(--text-muted) mt-1 text-start">
                {{ options?.subTitle | translate }}
            </p>
        </div>

        <button type="button" (click)="close()" class="modal-close-icon rtl:mr-auto! rtl:ml-0!">
            <img src="assets/icons/cancel.svg" alt="close" class="w-full h-full" />
        </button>
    </div>

    <div class="px-6 pt-2 pb-6 shadow-[0px_2px_20px_0px_#0000001A]">
        <!-- Search input -->
        <app-search *ngIf="options?.showSearch !== false" [placeholder]="options?.placeholder || ''" (searchChange)="onSearchChange($event)"
            extraClass="bg-white mt-1"></app-search>

        <!-- list -->
        <div class="max-h-80 overflow-y-auto">
            <div *ngFor="let item of filteredItems"
                class=" p-3 md:p-5 cursor-pointer border-b-[0.5px] border-[#DAE1E4] last:border-none text-medium hover:opacity-80 transition flex justify-between gap-4">
                <div class="flex items-center gap-3">
                    <img *ngIf="item.icon" [src]="item?.icon" alt="flag" class="w-6 h-6 rounded-full" />
                    <span class="text-start">{{ item?.label }}</span>
                </div>

                <div class="flex items-center gap-3">
                    <div class="w-6 h-6 rounded-full border flex items-center justify-center transition"
                        (click)="toggleSelection(item)" [ngClass]="{
            'bg-(--brand-primary) border-(--brand-primary)': isSelected(item.code),
            'border-(--text-placeholder)': !isSelected(item.code)
          }">
                        <img *ngIf="isSelected(item.code)" src="assets/icons/check-white.svg" class="w-3 h-3"
                            alt="checked" />
                    </div>
                </div>
            </div>
        </div>

        <!-- confirm -->
        <app-button text="{{ 'BUSINESS_ACTIVITY.CONFIRM' | translate }}" (action)="confirm()" type="button" [disabled]="selectedValues.length === 0"
            variant="primary" size="lg" extraClass="mt-6 w-full"></app-button>
    </div>


</div>